import { render, staticRenderFns } from "./TwoPhaseLoginInfoEdit.vue?vue&type=template&id=4a397d66&scoped=true"
import script from "./TwoPhaseLoginInfoEdit.vue?vue&type=script&lang=js"
export * from "./TwoPhaseLoginInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./TwoPhaseLoginInfoEdit.vue?vue&type=style&index=0&id=4a397d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a397d66",
  null
  
)

export default component.exports